import type { IconProps } from './types';

export const DownloadMinimalIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 17, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M15.8334 10.8333V11.8333C15.8334 13.2335 15.8334 13.9335 15.5609 14.4683C15.3212 14.9387 14.9388 15.3212 14.4683 15.5608C13.9336 15.8333 13.2335 15.8333 11.8334 15.8333H4.83337C3.43324 15.8333 2.73318 15.8333 2.1984 15.5608C1.72799 15.3212 1.34554 14.9387 1.10586 14.4683C0.833374 13.9335 0.833374 13.2335 0.833374 11.8333V10.8333M12.5 6.66666L8.33337 10.8333M8.33337 10.8333L4.16671 6.66666M8.33337 10.8333V0.833328"
        stroke={color}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
